import { analytics } from '../lib/firebase';
import { logEvent } from 'firebase/analytics';

type EventName = 
  | 'session_viewed'
  | 'session_created'
  | 'session_updated'
  | 'session_deleted'
  | 'invoice_generated'
  | 'payment_received'
  | 'user_login'
  | 'user_logout'
  | 'user_signup'
  | 'patient_created'
  | 'patient_updated'
  | 'patient_deleted'
  | 'settings_updated'
  | 'billing_profile_updated'
  | 'price_tier_updated'
  | 'error_occurred';

interface EventParams {
  [key: string]: any;
}

export const useAnalytics = () => {
  const trackEvent = async (eventName: EventName, eventParams?: EventParams) => {
    try {
      const analyticsInstance = await analytics;
      if (analyticsInstance) {
        logEvent(analyticsInstance, eventName, eventParams);
      }
    } catch (error) {
      console.error('Analytics error:', error);
    }
  };

  const trackPageView = async (pagePath: string, pageTitle: string) => {
    try {
      const analyticsInstance = await analytics;
      if (analyticsInstance) {
        logEvent(analyticsInstance, 'page_view', {
          page_path: pagePath,
          page_title: pageTitle,
        });
      }
    } catch (error) {
      console.error('Analytics error:', error);
    }
  };

  const trackError = async (error: Error, context?: string) => {
    await trackEvent('error_occurred', {
      error_message: error.message,
      error_stack: error.stack,
      context,
    });
  };

  return {
    trackEvent,
    trackPageView,
    trackError,
  };
}; 